import React from 'react'

import RoutesHelper from '../../../../helpers/RoutesHelper'

import { Toggle, Text, Button } from 'components/base'
import { providesChannelMutations } from 'components/Channels/dataSync'
import { LinkIcon } from 'components/Utils/Icons'
import IncentiveBox from 'components/Utils/IncentiveBox'
import copyOnClick from 'components/Utils/copyOnClick'

export type PublicSharingFormProps = {
  channel: any
  publiclyShareChannel: (options: { id: string }) => void
  publiclyUnshareChannel: (options: { id: string }) => void
}

export default providesChannelMutations(function PublicSharingForm({
  channel,
  publiclyUnshareChannel,
  publiclyShareChannel,
}: PublicSharingFormProps) {
  const canSharePublicly = channel.permissions.get('sharePublicly')
  const channelURL = channel.publiclySharedAt
    ? channel.shareLink
    : RoutesHelper.absoluteChannelShow({ channelId: channel.id })
  return (
    <React.Fragment>
      <div className="flexbox flexbox-align-center flexbox-space-between">
        <div>
          <Text.Section className="margin-bottom-small">
            Publish to the web
          </Text.Section>
          <Text.Corpus>
            Create a link to a public version of this channel.
          </Text.Corpus>
        </div>
        <div className="flexbox flexbox-align-center">
          <CopiablePublicLink
            slim
            link={channelURL}
            disabled={!channel.publiclySharedAt}
            className="margin-right-small"
          >
            <div className="flexbox flexbox-align-center">
              <LinkIcon size={12} className="margin-right-small" />
              <div>Copy link</div>
            </div>
          </CopiablePublicLink>
          <Toggle
            checked={Boolean(channel.publiclySharedAt)}
            disabled={!canSharePublicly}
            onChange={() =>
              Boolean(channel.publiclySharedAt)
                ? publiclyUnshareChannel({ id: channel.id })
                : publiclyShareChannel({ id: channel.id })
            }
          />
        </div>
      </div>

      <IncentiveBox
        incentiveId="ManagePublicChannels"
        className="margin-top-normal"
      />
    </React.Fragment>
  )
})

const CopiablePublicLink = copyOnClick({
  getContentFromProps: (props: { link:string }):string => props.link,
})(Button.Tertiary)
